APPS.pledge.fullpledge = (function(){
	/* 
		Populated by listening to outside events.
		See the onAttach section of this file.
	*/
	var pledgeData = {
		 type : "sustainer"
		,amount : ""
		,term : ""
		,gift:""
		,giftSfId:""
		,giftCategory:""
		,giftTitle:""
		,giftTicketLocation:""
		,giftTicketDate:""
		,giftTicketTime:""
		,endowment:""
	}
	
    var radio = Backbone.Radio.channel('pledgeform')


    var show = function(){
        console.log('APPS.pledge.fullpledge.show')
        APP.getView().showChildView('mainRegion',Backbone.Radio.channel('views').request('loading'))

    	APP.getView().showChildView('mainRegion', new pageView({}) );
    	
    	window.document.title = "Donate to WHRO Public Media";
    	
		if(ga || gtag){
			var formType = "Public";
			if(true == Backbone.settings.flags.volunteer){
				formType = "Volunteer";
			}else if(true == Backbone.settings.flags.callcenter){
				formType = "Call Center"
			}
			if(ga){ 
				ga('set','title',"Pledge Form - "+formType);
				ga('send','pageview');
			}
			if(gtag){
				gtag('set', { 'page_title': "Pledge Form - "+formType });
				gtag('event', 'page_view');
			}
		}
// 		console.log('test_tech',Backbone.settings.qs);
	    
    }





	/***************************************
		VIEWS 
	***************************************/
	// THE PAGE
		var pageView = Marionette.View.extend({
			 template: function(){
				var tmpl = "#tmpl-pledge-full";
				if(Backbone.settings.flags.volunteer || Backbone.settings.flags.callcenter){ tmpl = "#tmpl-pledge-volunteer"; }
 
				return _.template($(tmpl).html())
			}
			,className:"page_pledge_full mt8 pb8"
			,regions:{
				formDonation:{
					el: '#formDonationContainer'
				}
				,formPremiums:{
					el: '#formPremiumsContainer'
				}
				,formContacts:{
					el: '#formContactsContainer'
				}
				,formCurrentMember:{
					el: '#formCurrentMemberContainer'
				}
				,formPaymentMethod:{
					el: "#formPaymentMethodContainer"
				}
				,formMatchingGifts:{
					el: '#formMatchingGiftsContainer'
				}
				,formEndowment:{
					el: '#formEndowmentContainer'
				}
				,formStations:{
					el: '#formStationsContainer'
				}
				,formComments:{
					el: '#formCommentsContainer'
				}
				,formTerms:{
					el: '#formTermsContainer'
				}

			}
			,onRender: function() {
				this.showChildView('formDonation', Backbone.Radio.channel('views').request('form-donation',{
					model: this.model
				}));
				this.showChildView('formPremiums', Backbone.Radio.channel('views').request('form-premiums',{
						model: this.model
						,pledgeData:pledgeData
				}));
				this.showChildView('formContacts', Backbone.Radio.channel('views').request('form-contacts',{
						model: this.model
						,pledgeData:pledgeData
				}));
				this.showChildView('formCurrentMember', Backbone.Radio.channel('views').request('form-currentmember',{
						model: this.model
				}));
				this.showChildView('formPaymentMethod', Backbone.Radio.channel('views').request('form-paymentmethod',{
						model: this.model
						,pledgeData:pledgeData
				}));
				this.showChildView('formMatchingGifts', Backbone.Radio.channel('views').request('form-matchinggifts',{
						model: this.model
						,pledgeData:pledgeData
				}));
				this.showChildView('formEndowment', Backbone.Radio.channel('views').request('form-endowment',{
						model: this.model
						,pledgeData:pledgeData
				}));
				this.showChildView('formStations', Backbone.Radio.channel('views').request('form-stations',{
						model: this.model
						,pledgeData:pledgeData
				}));
				this.showChildView('formComments', Backbone.Radio.channel('views').request('form-comments',{
						model: this.model
						,pledgeData:pledgeData
				}));
				this.showChildView('formTerms', Backbone.Radio.channel('views').request('form-terms',{
						model: this.model
						,pledgeData:pledgeData
				}));
			}
			,onChildviewPageUpdated:function(e){
				//console.log('onChildviewPageUpdated',e)
			}
			,onAttach:function(){
				var that = this;
				
				/*
					Triggered from donation.js, which contains the Donation Type & Amount html/js 
				*/
				radio.on("donation:updated",function(data){
					console.log("received donation:updated",data)
					pledgeData.type = data.type;
					pledgeData.amount = data.amount;
					pledgeData.term = data.term;
					
					that.updateDonationButton();
					
				})
				
				/*
					Triggered from premium.js, which contains the list of premiums/gifts html/js 
				*/
				radio.on("premiums:updated",function(data){
					console.log("received premiums:updated",data)
					pledgeData.gift = data.id;
					pledgeData.giftSfId = data.sfid;
					pledgeData.giftCategory = data.category;
					pledgeData.giftTitle = data.title;
					pledgeData.giftTicketLocation=data.ticket_location;
					pledgeData.giftTicketDate=data.ticket_date;
					pledgeData.giftTicketTime=data.ticket_time;
					
				})
				
				/*
					Triggered from endowment.js
				*/
				radio.on("endowment:updated",function(data){
					console.log("received endowment:updated",data)
					pledgeData.endowment = data.endowment;
					
					that.updateDonationButton();
				})
				
				
				if(Backbone.settings.flags.volunteer || Backbone.settings.flags.callcenter){
					$('#publicMessage').hide()
		
					$('form').attr('autocomplete', 'off')

					$('.volunteer').show()
					$('#v_currentMember').addClass('volunteerText font-bold').css("line-height","1.25");
				}
				
				if(Backbone.settings.qs.technique == 'TextToMobilePledge'){
					$('#publicMessage').addClass('technique-custom');
				}
			}
			,events:{
				"click #submit" : "submitDonation"
			}
			,updateDonationButton:function(){
				//update the donate button text
				console.log('pd',pledgeData)
				var amount = pledgeData.amount.toString().split('.')
					,amountText = ""
					,endowAmount = 0;
				
				if(amount[1]){
					amount = pledgeData.amount
				}else{
					amount = amount[0]
				}
				
				if(pledgeData.type == "sustainer"){ amountText += "/month"; }
				
				if(pledgeData.endowment == 'ENDOW5'){
					if(pledgeData.type == 'sustainer'){
						endowAmount = 1;
					}else if(pledgeData.type == 'installment'){
						//installments are quarterly or monthly. Endowment is $1 per installment.
						endowAmount = (pledgeData.term=="Q")? 4 : 12;
					}else{ //one-time pledge
						endowAmount = 5;
					}
					
					amountText += ' <span style="font-size:14px">(includes $'+endowAmount+' for Endowment)</span>';
				}
				
				amount = accounting.formatMoney(+amount+endowAmount)
				
				this.$el.find('#submit').html('Donate '+amount + amountText)
			}
			,submitDonation:function(){
				$('.formErrorContainer').empty().hide();
				
				var tmpData = {}
				
				tmpData.volunteer = $.trim( this.$el.find('#volunteerInitials').val() )

				tmpData.technique = (Backbone.settings.qs.technique)?Backbone.settings.qs.technique:"";
				tmpData.source = (Backbone.settings.flags.volunteer)?'vol':(Backbone.settings.flags.callcenter)?'pronto':'online';
				tmpData.sourceCode = (Backbone.settings.qs.source)?Backbone.settings.qs.source:"";
				tmpData.program = (Backbone.settings.qs.program)?Backbone.settings.qs.program:"";

				tmpData.amount = pledgeData.amount
				tmpData.type = pledgeData.type;
				tmpData.term = pledgeData.term;
				tmpData.gift = pledgeData.gift;
				tmpData.giftSfId = pledgeData.giftSfId;
				tmpData.giftCategory = pledgeData.giftCategory;
				//the thank you page needs these
				tmpData.giftTitle = pledgeData.giftTitle; 
				tmpData.giftTicketLocation=pledgeData.giftTicketLocation;
				tmpData.giftTicketDate=pledgeData.giftTicketDate;
				tmpData.giftTicketTime=pledgeData.giftTicketTime;
				
				
				tmpData.cdname = this.$el.find('#cdName').val();
				
				//contacts
				tmpData.accountId = $.trim( $('#accountId').val() )
				tmpData.contactId = $.trim( $('#contactId').val() )
				tmpData.contactId2 = $.trim( $('#contactId2').val() )
				
				// is Sustainer
				if( $('#curSustainer').val() == "true" ){
					tmpData.vendorFlags = "SustainerUpgrade";
				}

					//if not "OTHER", use what they picked
				tmpData.title = (this.$el.find('#title').val().toLowerCase() != 'other')? this.$el.find('#title').val()
									// If "OTHER" AND the value in the 'other' input field matches the data attribute from the phone lookup, 
									//     use the value from the phone lookup. Else use what is in the 'other' input directly.                                        
									: ((this.$el.find('#nameTitleInput').val() == this.$el.find('#title').attr('data-text'))? this.$el.find('#title').attr('data-abbr') : this.$el.find('#nameTitleInput').val() );
				tmpData.fname = this.$el.find('#fname').val()
				tmpData.mname = this.$el.find('#mname').val()
				tmpData.lname = this.$el.find('#lname').val()
		
				//only use if visible on the screen
				if($('#fname2:visible').length){
					tmpData.title2 = (this.$el.find('#title2').val().toLowerCase() != 'other')? this.$el.find('#title2').val()
									// If "OTHER" AND the value in the 'other' input field matches the data attribute from the phone lookup, 
									//     use the value from the phone lookup. Else use what is in the 'other' input directly.                                        
									: ((this.$el.find('#nameTitleInput2').val() == this.$el.find('#title2').attr('data-text'))? this.$el.find('#title').attr('data-abbr') : this.$el.find('#nameTitleInput2').val() );
					tmpData.fname2 = this.$el.find('#fname2').val()
					tmpData.mname2 = this.$el.find('#mname2').val()
					tmpData.lname2 = this.$el.find('#lname2').val()
				}else{
					tmpData.title2 = '';
					tmpData.titleOther2 = '';
					tmpData.fname2 = '';
					tmpData.mname2 = '';
					tmpData.lname2 = '';
				}
				
				//use the primary email if both were entered for some reason
				tmpData.email = this.$el.find('#email').val()
				tmpData.phone = this.$el.find('#phone').val()
					//remove non-digits
					tmpData.phone = tmpData.phone.replace(/[^0-9]/g, '')

				tmpData.address = this.$el.find('#address').val()
				tmpData.address2 = this.$el.find('#address2').val()
				tmpData.city = this.$el.find('#city').val()
				tmpData.state = this.$el.find('#state').val()
				tmpData.zip = this.$el.find('#zip').val()

				tmpData.currentMember = (Backbone.settings.flags.pledgeDrive)? this.$el.find('input[name=isCurrentMember]:checked').val() : '';

				//payment method
				tmpData.paymentType = this.$el.find('#selectPaymentType').val()
				//credit card
				tmpData.ccnum = (tmpData.paymentType =='CREDITCARD')? this.$el.find('#ccNum').val() : '';
					tmpData.ccnum = tmpData.ccnum.replace(/[^0-9]/g, '')
				tmpData.ccmonth = (tmpData.paymentType =='CREDITCARD')? this.$el.find('#ccMonth').val() : '';
				tmpData.ccyear = (tmpData.paymentType =='CREDITCARD')? this.$el.find('#ccYear').val() : '';
				//eft
				tmpData.bankid = (tmpData.paymentType =='EFT')? this.$el.find('#bankId').val() : '';
					tmpData.bankid = tmpData.bankid.replace(/[^0-9]/g, '')
				tmpData.bankacct = (tmpData.paymentType =='EFT')? this.$el.find('#bankAcct').val() : '';
					tmpData.bankacct = tmpData.bankacct.replace(/[^0-9]/g, '') //there are no regs around this, but we think ACH must be all digits	


				//matching gifts
				tmpData.employer = this.$el.find('#employer').val()
				tmpData.employerId = this.$el.find('#employer').data('id')

				tmpData.shippingfee = pledgeData.endowment;
				tmpData.station = this.$el.find('input[name=stations]:checked').val();
				tmpData.thankyou = this.$el.find('input[name=thankyou]:checked').val()
				tmpData.thankyoutext = (tmpData.thankyou == '1')? this.$el.find('#thankYouComment').val() : ''; 
				if(tmpData.thankyou == '1' && tmpData.thankyoutext==''){ tmpData.thankyoutext="[No comment. May thank on air.]" }
				tmpData.comments = this.$el.find('#comments').val().replace(/(\r\n|\n|\r)/gm," ");


				//console.log('tmpData',tmpData);return;


				//validate fields
				var errors = validateFields(tmpData)

				if(errors.length){
					showErrors(errors);
					return;
				}else{
					$('.formErrorContainer').empty()
				}
				
				//tmpData.pledgeid='999999';Backbone.Radio.channel('pledge').request("thankyoufull",tmpData);return;

				review(tmpData);
				return;
			}
		})
    
    
		function validateFields(values){
			console.log(values)
			var errors = [],
				i = 0;

			if( Backbone.settings.flags.volunteer && !values.volunteer ){ errors[i++] = { 'text': "Enter volunteer's name.", 'field':'volunteerInitials' } }
            	
			if(!values.amount || accounting.toFixed(values.amount,2) == 0.00 || values.amount <= 0){
				errors[i++] = { 'text': "Enter a donation amount." }; 
			}else if(values.amount < 1){
				errors[i++] = { 'text': "Minimum pledge amount is $1.00." }; 
			}
			
			//selected a gift of higher value than their pledge
			if(values.gift){
				var giftAmount = 0;
				giftAmount = $('#gifts .selected [name=gifts][value='+values.gift+']').data('amount')
				
				if( giftAmount > values.amount){
					errors[i++] = { 'text': "Gift chosen is more than pledge amount. Raise pledge amount or select another gift." }
				}
			}


			//required fields
			if( !values.fname ){ errors[i++] = { 'text': "Enter your first name.", 'field':'fname' } }
			if( !values.lname ){ errors[i++] = { 'text': "Enter your last name.", 'field':'lname' } }
			if( !values.address ){ errors[i++] = { 'text': "Enter your street address.", 'field':'address' } }
			if( !values.city ){ errors[i++] = { 'text': "Enter your city.", 'field':'city' } }
			if( !values.zip ){ errors[i++] = { 'text': "Enter a 5 or 9 digit zip code.", 'field':'zip' } }
			if( !values.station ){ errors[i++] = { 'text': "Select a station.", 'field':'station' } }
			
			//email is not required, so only check it if they give us one
			if( values.email && !(/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(values.email)) ){
				errors[i++] = { 'text': "Enter a valid email address.", 'field':'email' } 
			}
			//phone
			if(values.phone.length != 10){
				errors[i++] = { 'text': "Enter your phone number including area code.", 'field':'phone' }
			}
			
			//credit card
			if( values.paymentType == 'CREDITCARD' ){
				if(!Backbone.settings.flags.callcenter){
					if( !Backbone.Radio.channel('utilities').request('creditCardValidate',{'ccNum':values.ccnum}) ){
						errors[i++] = { 'text': "Enter a valid credit card number.", 'field':'ccNum' }
					}
				}else{ //pronto is based on some IE7 insanity and always fails our checksum, so just check that a value exists and that it is all digits
					values.ccnum = values.ccnum.replace(/\D/g,'');
					if(!values.ccnum){ errors[i++] = { 'text': "Enter a valid credit card number.", 'field':'ccNum' } }
				}
				
				var d = new Date(),
					thisYear = ('0' + d.getFullYear()).slice(-2),
					thisMonth = ('0' + (d.getMonth()+1)).slice(-2);
				if(values.ccyear == thisYear && values.ccmonth < thisMonth){ //cc and ccyear is this year and month is less than this month
					errors[i++] = { 'text': "Enter a valid credit card expiration.", 'field':'ccMonth' }
				} 
			//eft - checking
			}else if( values.paymentType == 'EFT' ){
				if( !Backbone.Radio.channel('utilities').request('routingNumberValidate', values.bankid) ){
					errors[i++] = { 'text': "Enter a valid bank routing number.", 'field':'bankId' }
				}
				//No real validation can be done around account numbers. We think ACH must be all digits and under 18 length
				// http://stackoverflow.com/questions/1540285/united-states-banking-institution-account-number-regular-expression
				if(values.bankacct.length==0 || values.bankacct.length > 17){
					errors[i++] = { 'text': "Enter a valid bank account number.", 'field':'bankAcct' }
				}
			}

			
			//terms agreed to if needed
			if($('#terms:visible').length && $('#terms:checked').length==0){
				errors[i++] = { 'text': "Please Review and Agree to the Terms (They're right above the Donate button)." }
			}
			
			return errors;
		}
		
		function showErrors(errors){
			var i,l,htm="";
			
			if(errors){
				for(i=0,l=errors.length;i<l;i++){
					htm += "<li>" + ((typeof errors[i]==="string")?errors[i]:errors[i].text) + "</li>";
					if(errors[i].field){
						$('#error-'+errors[i].field).show() 
						if(errors[i].field == 'pledgeAmount' || errors[i].field == 'sustainerAmount' ){ 
							$('#'+errors[i].field).trigger('change') 	
						}else{
							$('#'+errors[i].field).trigger('blur') 
						}
					}
				}
			}else{ //server errors don't always come back formatted, so just throw something
				htm = "Unknown server error."; 
			}
			$('.formErrorContainer').empty().removeClass("alert-success").append('<h1 class="h2 danger">Hmm... looks like there\'s an error.</h1><ul>'+htm+'</ul>').show();
		}

		function review(values){
			$('#pledge-form-content').hide();
			window.scrollTo(0,0);
			$('#pledge-form-review').show().find('.clearable').empty();
			
			populatePledgeData( values, $('#pledge-form-review') )
			
			var giftMessage = '';
			if(values.gift!="" && values.gift != 'NOGIFT'){			
				//PT #134614343 - treat all gifts the same regardless of pledge type
				//	-- except tickets, see the morass that is PT #151324424
				if(values.giftCategory==="Tickets"){
					if(values.gift=="P20460"){ // PT #171282790 - Antique's Roadshow 2020
						giftMessage += "<p>ANTIQUES ROADSHOW tickets will be delivered electronically to the email address on file. You must have a ticket printout to enter the appraisal event.</p>";
					}else{
						giftMessage += "<p>The tickets you requested, as a thank you, will be held at the box office, will-call window.</p>";
					}
				}else{
					giftMessage += "<p>Your gift of appreciation will be shipped within 6 - 8 weeks.</p>";
					//giftMessage += "<p>Here at WHRO we strive to give each and every one of our donors the best in not just programing, but also customer service. We are trying our very hardest to get each gift delivered by the holidays. If your gift does not arrive before your big day please use the link below to print a certificate that you can give to your loved one with the knowledge that their gift is on its way. A printed certificate will also arrive along with your acknowledgement letter.</p><p><a href='/img/HolidayVoucher2017.jpg' target='_blank'>Holiday Certificate (click to view)</a></p>"
				}
			}
			$('#gift_Volunteer').empty().html(giftMessage)

			var message = '';
			if(Backbone.settings.flags.volunteer || Backbone.settings.flags.callcenter){
				//they had a matching gift match
				if(values.employerId){
					if(values.email){
						message += '<p>You indicated your employee takes part in a matching gift program. <br>Detailed information about matching your gift will be emailed to you shortly.</p>';
					}else{
						message += '<p>You indicated your employer takes part in a matching gift program. <br>Please see your human resources department for instructions on matching your gift.</p>';
					}
				}
			}
			$('#matchingGift_Volunteer').empty().html(message)
			
			
			/* Events */
			$('body').off('click.review');
			$('body').on('click.review','#savePledge',function(){ 
				if($(this).hasClass('disabled')){
					return;
				}else{
					$(this).addClass('disabled');
					savePledge(values);
				}
			});
			$('body').on('click.review','#editPledge',function(){ $('.formErrorContainer').empty(); $('#pledge-form-review').hide(); $('#pledge-form-content').show() })
			
			$(window).unbind('.review').bind('beforeunload.review', function(){ //prevent people from leaving the review page thinking they submitted the form
				if( $('#pledge-form-review').is(':visible') ){
					return "You have not submitted your pledge. Press 'Stay on this Page' or 'Cancel' to stay and submit your pledge.";
				}
				return;
			});
		}
		
		function populatePledgeData(values, context, options){
			o = $.extend({
				'maskCC' : false	
			}, options);
			
			context.find('.review_name').html( ((values.titleOther)?values.titleOther:values.title) + " " + values.fname + " " + values.mname + " " + values.lname)
			context.find('.review_name2').html( ((values.titleOther2)?values.titleOther2:values.title2) + " " + values.fname2 + " " + values.mname2 + " " + values.lname2)
			context.find('.review_address1').html(values.address)
			context.find('.review_address2').html(values.address2)
			context.find('.review_address3').html(values.city + ", " + values.state + " " + values.zip)
			context.find('.review_email').html( (values.email)?values.email:'&nbsp;')
			context.find('.review_employer').html( (values.employer)?values.employer:'&nbsp;' )
			context.find('.review_phone').html(values.phone.replace(/\D+/g, '').replace(/(\d{3})(\d{3})(\d{4})/, '($1) $2-$3'))
			
			context.find('.review_donationType').html( (values.type == "sustainer")? 'Sustainer (Monthly Ongoing)' : 'One-Time Pledge' ); 
				if( values.type != 'sustainer' && (typeof values.term != 'undefined' && values.term != '') ){
					context.find('.review_donationType').html('Installments')
				}

			//figure out what to show for pledge amount since endowment changes things							  
			var amount = values.amount,
				amountText = '', 
				q = 0,
				installmentAmount = 0;
			
			if(values.type == "sustainer"){ amountText += "/month"; }

			if(values.shippingfee == 'ENDOW5'){
				var endowAmount = getEndowmentAmount(values);
				
				amountText += ' <span style="font-size:14px">(includes $'+endowAmount+' for Endowment)</span>';
				amount = accounting.toFixed(+amount+endowAmount, 2)
			}
			
			if( values.type == 'sustainer' || values.term == '' ){
				context.find('.review_installmentLabel,#review_installment').hide()
			}else{
				context.find('.review_installmentLabel,#review_installment').show()
				
				if( values.term == 'Q' ){
					context.find('.review_installmentLabel').html('Quarterly Total')
					installmentAmount = accounting.toFixed((+amount / 4) , 2)
				}else if( values.term == 'M' ){
					context.find('.review_installmentLabel').html('Monthly Total')
					installmentAmount = accounting.toFixed((+amount / 12),2)
				}
				context.find('.review_installment').html('$'+installmentAmount)
			}
			
			context.find('.review_amount').html('$' + amount + amountText)

			var tmpPayText = 'Credit Card';
			if(values.paymentType == "EFT"){ tmpPayText = 'Checking Account (EFT)'; }
			if(values.paymentType == "SendBill"){ tmpPayText = 'Check'; }
			//the looked up options
			if(values.paymentType == "CREDITCARD" && values.guid){ tmpPayText = 'Using Existing Credit Card'; }
			if(values.paymentType == "EFT" && values.guid){ tmpPayText = 'Using Existing Checking Account (EFT)'; }		
			context.find('.review_paymentType').html( tmpPayText )
	
			var paymentDetailsText = "";
			if(values.paymentType == "CREDITCARD"){ 
				if(values.ccnum){
					var ccNum = values.ccnum;
					if(o.maskCC){ ccNum = Array(ccNum.length-4).join('*') + ccNum.slice(-4)	}
					paymentDetailsText = ccNum + " (" + values.ccmonth + "/" + values.ccyear + ")";
				}else{ //existing # from sustainer lookup
					var tmpDate = values.charge_expire_date.split("-");
					paymentDetailsText = "************"+values.cclastfour + " (" + tmpDate[1] + "/" + tmpDate[2] + ")";
				}
			}else if(values.paymentType=="EFT"){ 
				if(values.guid){ //existing # from sustainer lookup
					paymentDetailsText = 'Routing Number: '+values.bankid+"<br>Account Number: ********"+values.bankacct 	
				}else{
					paymentDetailsText = 'Routing Number: '+values.bankid+"<br>Account Number: "+values.bankacct 
				}
			}else{ //check
				paymentDetailsText = "You will receive an invoice reminder in the mail very soon.";
			}
			context.find('.review_paymentDetails').html( paymentDetailsText )
			
			var giftText = $('#giftList input[value="'+values.gift+'"]').siblings('.giftTitle').html();
			context.find('.review_gift').html( (giftText)?giftText:"No Gift - Apply entire donation towards programming" )
	
			if(values.thankyou == '1'){
				context.find('.review_thankyou').html(values.thankyoutext).parent('.row').show();
			}else{
				context.find('.review_thankyou').parent('.row').hide();
			}
			context.find('.review_comments').html(values.comments)	

		}

		function getEndowmentAmount(values){
			var endowAmount = 0;
				if(values.shippingfee == 'ENDOW5'){
				if(values.type == 'sustainer'){
					endowAmount = 1 
				}else if($('#installmentTab').hasClass('ui-tabs-active')){
					//installments are quarterly or monthly. Endowment is $1 per installment.
					endowAmount = ($('#paymentTerms').val()=="Q")? 4 : 12;
				}else{ //one-time pledge
					endowAmount = 5;
				}
			}
			return endowAmount;
		}

		function savePledge(values){
			if(Backbone.settings.qs.testmode){ values.testmode=true; }
			
			var save = $.ajax({
				 url:APP_CONFIG.SALESFORCE_API_ROOT+"pledge"
				,type:'POST'
				,dataType:'json'
				,data:JSON.stringify(values)
			})
			save.done(function(data){
				$('#savePledge').removeClass('disabled')
				
				//console.log('submit pledge done',data)
				if(data && data.success===true){
					values.pledgeid = data.pledgeid;
					
					var formType = "Public";
					if(true == Backbone.settings.flags.volunteer){
						formType = "Volunteer";
					}else if(true == Backbone.settings.flags.callcenter){
						formType = "Call Center"
					}
					var endowAmount = getEndowmentAmount(values);
					var amount = +values.amount + endowAmount;
					if(values.type=="sustainer"){ amount = amount*12; }
					if(ga){ ga('send', 'event', 'Pledge', formType, values.type, amount); }
					if(gtag){
						gtag('event', formType, {
							'event_category': 'Pledge',
							'event_label': values.type,
							'value': amount
						});
					}
					
					Backbone.Radio.channel('pledge').request("thankyoufull",values)		
				}else{			
					showErrors(data.errors);
				}
			});
			
			//this is for when the server call itself failed, not that the server handled the call and sent back an app error
			save.fail(function(data, status, error){
				$('#savePledge').removeClass('disabled')
				
				alert('Server Error: Try again later.')
				//console.log('failed',data);
				//console.log('failed',status);
				//console.log('failed',error);
			})

		}
		
	return {
		show:show
	}
})();